import { storage } from '@itau-loans-www/utils'

import common from '../common/consignado'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (key) => {
  const hasINSSOffer = storage.session.getItem(`${storageName}_leadData`)
    ?.tracking?.hasINSSOffer

  const commonParameters = common()

  const payloadsMap = {
    'btn:whatsapp-flutuante': {
      custom_path: '/emprestimo/consignado/home',
      detail: 'btn:whatsapp-flutuante',
      ...commonParameters
    },
    'btn:contratar-via-whatsapp': {
      custom_path: '/emprestimo/consignado/home',
      detail: 'btn:contratar-via-whatsapp',
      ...commonParameters
    },
    'btn:simular-agora': {
      custom_path: '/emprestimo/consignado/home',
      detail: 'btn:simular-agora',
      ...commonParameters
    },
    'btn:simular-agora-flutuante': {
      custom_path: '/emprestimo/consignado/home',
      detail: 'btn:simular-agora-flutuante',
      ...commonParameters
    },
    'btn:oferta-especial-desbloquear': {
      custom_path: `/emprestimo/consignado/${
        hasINSSOffer ? 'com-oferta' : 'sem-oferta'
      }`,
      detail: 'btn:oferta-especial-desbloquear',
      ...commonParameters
    },
    'btn:finalizar-no-whatsapp-dados-pessoais': {
      custom_path: '/emprestimo/consignado/formalizacao/dados-pessoais',
      detail: 'btn:finalizar-no-whatsapp',
      ...commonParameters
    },
    'btn:finalizar-no-whatsapp-documento': {
      custom_path: '/emprestimo/consignado/formalizacao/documento',
      detail: 'btn:finalizar-no-whatsapp',
      ...commonParameters
    },
    'btn:finalizar-no-whatsapp-endereco': {
      custom_path: '/emprestimo/consignado/formalizacao/endereco',
      detail: 'btn:finalizar-no-whatsapp',
      ...commonParameters
    },
    'btn:finalizar-no-whatsapp-dados-bancarios': {
      custom_path: '/emprestimo/consignado/formalizacao/dados-bancarios',
      detail: 'btn:finalizar-no-whatsapp',
      ...commonParameters
    },
    'btn:acessar-app-itau': {
      custom_path: '/emprestimo/consignado/finalizacao/ep-op',
      detail: 'btn:acessar-app-itau',
      ...commonParameters
    },
    'btn:renegociacao-acessar-pagina': {
      custom_path: '/emprestimo/consignado/finalizacao/renegociacao',
      detail: 'btn:renegociacao-acessar-pagina',
      ...commonParameters
    },
    'btn:acessar-pagina-recovery': {
      custom_path: '/emprestimo/consignado/finalizacao/recovery',
      detail: 'btn:acessar-pagina-recovery',
      ...commonParameters
    },
    'btn:cgi-acessar-formulario': {
      custom_path: '/emprestimo/consignado/finalizacao/cgi',
      detail: 'btn:cgi-acessar-formulario',
      ...commonParameters
    },
    'btn:acessar-pagina': {
      custom_path: '/emprestimo/consignado/finalizacao/cartao-pda',
      detail: 'btn:acessar-pagina',
      ...commonParameters
    },
    'btn:conta-itau-acessar-pagina': {
      custom_path: '/emprestimo/consignado/finalizacao/conta-itau',
      detail: 'btn:conta-itau-acessar-pagina',
      ...commonParameters
    },
    'btn:preciso-de-ajuda': {
      custom_path: '/emprestimo/consignado/proposta-bloqueada',
      detail: 'btn:preciso-de-ajuda',
      ...commonParameters
    },
    'btn:acessar-app-meu-inss': {
      custom_path: '/emprestimo/consignado/proposta-bloqueada',
      detail: 'btn:acessar-app-meu-inss',
      ...commonParameters
    }
  }

  return payloadsMap[key] ?? {}
}
